export { default as DatatableVariationGroups } from './VariationGroups';
export { default as DatatableVariationGroupsTemplate } from './VariationGroupsTemplates';
